import { smallMax } from '@do/walrus/MediaQueries';
import colors from '@do/walrus/scss/core/_colors.scss';
import vars from '@do/walrus/scss/core/_variables.scss';
import * as React from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import Coral1 from '../assets/backgrounds/coral-1.png';
import Coral2 from '../assets/backgrounds/coral-2.png';
import Coral3 from '../assets/backgrounds/coral-3.png';
import { HEADER_HEIGHT } from '../constants';

const BackgroundElt = styled.div`
  position: fixed;
  z-index: ${vars.z_index_base};
  top: ${HEADER_HEIGHT}px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.primary_bg};
  background-size: cover;
`;

interface Props {
  url?: string;
  verticalPosition?: string;
  horizontalPosition?: string;
  color?: string;
}

const Background: React.FC<Props> = ({
  url,
  verticalPosition = 'center',
  horizontalPosition = 'center',
  color = colors.primary_bg
}) => {
  return (
    <BackgroundElt
      style={{
        backgroundImage: `url(${url})`,
        backgroundPosition: `${horizontalPosition} ${verticalPosition}`,
        backgroundColor: color
      }}
    />
  );
};

interface BackgroundPositionedImageProps {
  src: string;
  height: string;
  width: string;
  left?: string;
  right?: string;
}

/**
 * This is to prevent side scrolling because the corals are placed partially off the screen
 */
const BodyOverFlowStyle = createGlobalStyle`
  body {
    overflow-x: hidden;
  }
`;

const BackgroundPositionedImage = styled.div<BackgroundPositionedImageProps>`
  position: fixed;
  bottom: 0;
  background-size: cover;
  z-index: ${vars.z_index_base};

  ${smallMax} {
    display: none;
  }

  ${({ src, height, width }) =>
    css`
      background-image: url(${src});
      height: ${height};
      width: ${width};
    `}

  right: ${({ right }) =>
    css`
      ${right}
    `};
  left: ${({ left }) =>
    css`
      ${left}
    `};
`;

export const CoralBackground: React.FC = () => (
  <>
    <BodyOverFlowStyle />
    <Background color="#E5E7EE" />
    <BackgroundPositionedImage
      src={Coral1}
      height="527px"
      width="310px"
      left="-15px"
    />
    <BackgroundPositionedImage
      src={Coral3}
      height="403px"
      width="205px"
      right="-25px"
    />
    <BackgroundPositionedImage
      src={Coral2}
      height="676px"
      width="308px"
      right="25px"
    />
  </>
);

export default Background;
